import { Store } from "pullstate";
export default new Store({
  fcmToken: "",
  RNfcmToken: "",
  user: {},
  formDetails: {},
  reportDetails: {},
  uploadModal: {
    isOpen: false,
    hasCurrentPatient: false
  },
  isEditPatientOpen: false,
  isLogoutOpen: false,
  sharingPatient: 0,
  isGetFullAccessOpen: true,
  enableViewerAPICall: true,
  enableSidebarAPICall: false,
  patient: {},
  patientDetail: {},
  isDarkMode: null,
  isExportDataOpen: false,
  isStartingDownload: false,
  isChangeRegionModalOpen: false,
  isFindingsSettingsOpen: false,
  isAutomatedConditionOpen: false,
  isCreateUserGroup: false,
  isAutomatedFindingsOpen: false,
  isMatchingPatientOpen: false,
  isFormSelectorVisible: false,
  formName: "",
  formId: "",
  isIncomingForm: false,
  emergencyPatientId: null,
  isEmergencyModalOpen: false,
  isConfirmationModalOpen: false,
  userSettings: {},
  appConfig: {},
  downloadExport: false,
  isExportReady: false,
  downloadProgress: 0,
  exportTimestamp: "",
  exportGenFailed: false,
  swiftModeEnabled: false,
  isRNTestBuild: false,
  RNSelectedEnv: "PROD",
  isRNEnvSelectorOpen: false,
  showExportUpdate: false,
  isRNAppStateChange: false,
  RNAppVersion: "",
  newPatientId: "",
  isNotificationSubscribing: false,
  showMobileStudySelector: false,
  hasUpdatedStudy: false,
  isRemoteAccessOpen: false,
  showMobileReport: false,
  isQXRModality: false,
  addPhoneModal: false,
  hasLicenseExpiredForSelectedPatient: false,
  isSettingsOpen: false,
  showCsvUploadModal: false,
  hasUnsavedSetting: false,
  selectedSetting: "",
  settingPageNo: 0,
  settingParams: {},
  showUnsavedWarning: false,
  isDiskSpaceWarning: false,
  patientsFileDeletionStatus: "",
  radiologistReport: {
    report: {},
    loading: true,
    errorMessage: ""
  },
  refetchRadiologistReport: false,
  refreshLCFilterCount: true,
  affectedTagIds: [],
  worklistSyncStatus: {},
  hasMobileSearch: false,
  worklistCloudSyncStatus: {},
  isqTrack: false,
  placheholderForAdminViewFlag: true,
  isAssistantOpen: false,
  isDraggableModalOpen: false,
  isDraggableModalMinimized: false,
  isDraggableModalMaximized: false,
  chatInputContent: "",
  formList: {},
  customFields: [],
  isLetterSelectorVisible: false,
  refetchCustomFields: false,
  lastAssitantMessageId: "",
  isPastChatOpen: false,
  assistantThreadId: "",
  accessPastChat: false,
  hasUserSentMessage: false,
  isUsingOrchestrator: false,
  isWorklistLoaded: false,
  changeInAIAssistantWidth: 0,
  aiAssitantWidth: 400,
  isAiAssistantOpen: true,
  currentPatientIdInAssistant: "",
  areFrontendToolsEnabled: true,
  saveFallbackToolCall: false,
  assistantMode: "simple",
  hasChosenAssistantMode: false,
  lastSavedMessageId: "",
  wsEvents: {},
  setToolCallMessages: function setToolCallMessages() {},
  getToolCallMessages: function getToolCallMessages() {
    return [];
  },
  lastSavedUserMessageId: "",
  customSuggestions: [],
  patientConversations: [],
  refetchPatientConversations: function refetchPatientConversations() {},
  selectedFilterPatientTool: false,
  lastConversationId: "",
  currentPatientsUsingOrchestrator: {},
  completedOrchestratorPatients: {},
  openAira: false,
  isWorklistCollapsed: false,
  selectedNextStep: null,
  isSummaryCollapsed: false,
  letterTemplateQueryResponse: null,
  initialSummaryView: null,
  scrollToPatientUid: null
});